import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";
import showErrorToast, { showSuccessToast } from "../../components/CustomComponents/toast/toast.js";
import Select from 'react-select';
import DropDownStyles from "./dropdownStyles.js";
import APIs from "../../Constants/apis.js";
import swal from 'sweetalert';
import Pagination from "../../components/CustomComponents/Pagination/pagination.js";
import PageSizeDropDownSelection, { SortOrderDropDownSelection } from "../../components/CustomComponents/DropdownSelections/DropDownSelections.jsx";
import { logout } from "../../app/auth/authSlice.js";

function ManageStaff() {
  const CompID = useSelector((state) => state.auth.user).userData?.compID;
    const navigate = useNavigate();
    const dispatch = useDispatch();
  
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState({ value: '50', label: '50' });
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [sortBy, setSortBy] = useState({ value: "UserName", label: "User Name" });
  const [sortOrder, setSortOrder] = useState({ value: "DESC", label: "Desc" });
  const [staffs, setStaffs] = useState([]);
  const [loading, setLoading] = useState(false);


  const sortByOptions = [
    { value: "UserName", label: "User Name" },
    { value: "email", label: "Email" },
    { value: "PhoneNo", label: "Phone" },
    { value: "RatePerHour", label: "Rate" }
  ];

  const FetchStaffs = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_COMPANY_STAFF, {
        params: {
          CompID,
          SortBy: sortBy.value,
          SortOrder: sortOrder.value,
          Search: search?.trim() || "",
          PageSize: pageSize.value,
          PageNumber: pageNumber,
        },
      });

      const staffData = response.data.data || response.data;

      if (Array.isArray(staffData)) {
        setStaffs(staffData);
        setTotalRecords(response.data.totalRecords);
        setTotalPages(response.data.totalPages);
      } else {
        console.error("Unexpected API response format");
        setStaffs([]);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 401) {
        dispatch(logout());
        setTimeout(() => {
          navigate("/user/login", { replace: true });
        }, 0);
      }
    }
  }, [search, pageSize, sortBy, sortOrder, pageNumber, CompID]);

  const DeleteStaff = async (staff) => {
    const confirmDelete = await swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete ${staff.userName}?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirmDelete) {
      return;
    }

    setLoading(true);
    try {
      await axiosInstance.delete(APIs.DELETE_COMPANY_STAFF, {
        params: {
          CompID: staff.compID,
          UserName: staff.userName
        },
      }).then(response => {
        if (response.data.status) {
          setStaffs((prevStaffs) => prevStaffs.filter((delStaff) => delStaff.userName !== staff.userName));
          showSuccessToast("Staff is Deleted.");
        }
        else
          showErrorToast(response.data.message);
      });
      setLoading(false);
    } catch (err) {
      showErrorToast("Something Went wrong.");
      setLoading(false);
      console.log(err);
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      FetchStaffs();
    }, 1000);
    return () => clearTimeout(handler);
  }, [FetchStaffs]);

  return (
    <div>
      {loading && (<Preloader />)}
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Home</a>
            </li>
            <li className="breadcrumb-item active">ManageStaff</li>
          </ol>
          <h1 className="page-header mb-0">ManageStaff</h1>
        </div>

        <div className="ms-auto">
          <Link to="/staff/AddStaff">
            <button className="btn btn-success btn-rounded px-4 rounded-pill">
              <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
              Add Staff
            </button>
          </Link>
        </div>
      </div>

      <div className="mb-3 d-sm-flex fw-bold">
        <div className="mt-sm-0 mt-2">
          <a href="#/" className="text-dark text-decoration-none">
            <i className="fa fa-download fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            Export
          </a>
        </div>
        <div className="ms-sm-4 ps-sm-1 mt-sm-0 mt-2">
          <a href="#/" className="text-dark text-decoration-none">
            <i className="fa fa-upload fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            Import
          </a>
        </div>
        <div className="ms-sm-4 ps-sm-1 mt-sm-0 mt-2 dropdown-toggle">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            className="text-dark text-decoration-none"
          >
            <i className="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            More Actions
          </a>
          <div className="dropdown-menu">
            <a className="dropdown-item" href="#/">
              Action
            </a>
            <a className="dropdown-item" href="#/">
              Another action
            </a>
            <a className="dropdown-item" href="#/">
              Something else here
            </a>
            <div role="separator" className="dropdown-divider"></div>
            <a className="dropdown-item" href="#/">
              Separated link
            </a>
          </div>
        </div>
      </div>

      <div className="card border-0">
        <div className="tab-content p-3">
          <div className="tab-pane fade show active" id="allTab">
            <div className="input-group mb-3">
              <div className="flex-fill position-relative">
                <form>
                  <div className="input-group mb-3">
                    <div className="flex-fill position-relative">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control ps-35px bg-light"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search staff ..."
                        />

                        <PageSizeDropDownSelection
                          defaultValue={pageSize}
                          onChange={setPageSize}
                        />

                        <Select
                          defaultValue={sortBy}
                          onChange={setSortBy}
                          options={sortByOptions}
                          styles={DropDownStyles}
                        />

                        <SortOrderDropDownSelection
                          defaultValue={sortOrder}
                          onChange={setSortOrder}
                        />

                      </div>
                    </div>

                    <button type="submit" className="btn btn-white">
                      <b className="fa fa-search opacity-5"></b>
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="table-responsive" style={{ minHeight: "200px" }}>
              <table className="table table-hover text-nowrap">
                <thead>
                  <tr>
                    <th className="pt-0 pb-2"></th>
                    <th className="pt-0 pb-2">Name</th>
                    <th className="pt-0 pb-2">Email</th>
                    <th className="pt-0 pb-2">Phone Number</th>
                    <th className="pt-0 pb-2">Country</th>
                    <th className="pt-0 pb-2">Status</th>
                    <th className="pt-0 pb-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {staffs.map((staff, index) => (
                    <tr>
                      <td className="w-10px align-middle">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="product1"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="product1"
                          ></label>
                        </div>
                      </td>
                      <td className="align-middle" onClick={() => {
                          navigate(
                            `/Staff/updateStaff/${staff.userName}`,
                          );
                        }}style={{ cursor: "pointer" }}>{staff.userName}</td>
                      <td className="align-middle" onClick={() => {
                          navigate(
                            `/Staff/updateStaff/${staff.userName}`,
                          );
                        }}style={{ cursor: "pointer" }}>{staff.email}</td>
                      <td className="align-middle" onClick={() => {
                          navigate(
                            `/Staff/updateStaff/${staff.userName}`,
                          );
                        }}style={{ cursor: "pointer" }}>{staff.phoneNo}</td>
                      <td className="align-middle" onClick={() => {
                          navigate(
                            `/Staff/updateStaff/${staff.userName}`,
                          );
                        }}style={{ cursor: "pointer" }}>{staff.country}</td>
                      <td className="align-middle">
                        {staff.active ?
                          <span className="badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                            <i className="fa fa-circle fs-9px fa-fw me-5px"></i>{" "}
                            Active
                          </span>
                          :
                          <span className="badge border border-warning text-warning px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                            <i className="fa fa-circle fs-9px fa-fw me-5px"></i>{" "}
                            Pending
                          </span>
                        }
                      </td>
                      <td>
                        <Link
                          to={`/staff/UpdateStaff/${staff.userName}`}
                          className="ms-3"
                        >
                          <span className="fas fa-pencil"></span>
                        </Link>
                        <span
                          onClick={() =>
                            DeleteStaff(staff)
                          }
                          className="fas fa-trash ms-3"
                          style={{ cursor: "pointer", color: "red" }}
                        ></span>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Pagination
              totalRecords={totalRecords}
              pageSize={pageSize.value}
              pageNumber={pageNumber}
              totalPages={totalPages}
              setPageNumber={setPageNumber}
            />

          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageStaff;
